import styled from 'styled-components'


export const AttendanceMonthlyCard = styled.div<{ color?: string }>`
    position: relative;
    width: 24px;
    height: 24px;
    border-radius: 8px;
    background-color: ${props => props.color ?? props.theme.colorNeutrals700};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color:${props => props.theme.appBackground};
    font-size: 12;
    font-weight: bold;
`

export const AttendanceWeeklyCard = styled.div<{ color?: string }>`
    position: relative;
    border-radius: 10px;
    background-color: ${props => props.color ?? props.theme.colorNeutrals700};
    cursor: pointer;
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    flex-direction: column;
    padding: 0 1rem;
    justify-content: center;

    .offset{
        background-color: white;
        padding:1px;
        border-radius: 5px;
    }

`

export const AttendanceOptionsWrapper = styled.div<{ right?: boolean, up?: boolean }>`
    position: absolute;
    z-index: 999999999999999999;
    width: 15rem;
    ${props => props.right ? 'right:0' : 'left:0'};
    /* ${props => props.up ? 'bottom:100%' : 'top:100%'}; */
    top:100%;
    ${props => props.theme.content};
    backdrop-filter: blur(13.2px);
    border-radius: 8px;
    border-radius: 10;
    overflow: hidden;
`

export const AttendanceOption = styled.div`
 cursor: pointer;
    height: 32px;
    width: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s ease;
    &:hover {
      background: #ff9900
    }
`